import { Delete, OpenInNew } from "@mui/icons-material";
import { Box, Card, CardActionArea, CardContent, Checkbox, Chip, IconButton, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { Fragment } from "react";
import { styled } from '@mui/material/styles';
import './style.css';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))

function stripHtml(html = "") {
    const tmp = document.createElement("div")
    tmp.innerHTML = html;
    return tmp.textContent || ""
}

function formatDate(str) {
    if (!str) return "";
    return new Date(str).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    })
}

const KnowledgeBaseCard = ({ item, onClick, onDelete, selectable = false, selected = false }) => {
    const desc = stripHtml(item.description)
    const keywordsList = item.knowledgebaseknowledgebasekeywords
    const keywords = (item.knowledgebaseknowledgebasekeywords || []).slice(0, 2)
    const moreKeywords = (item.knowledgebaseknowledgebasekeywords || []).slice(2)

    return (
        <Card
            variant="outlined"
            sx={{
                borderColor: "divider",
                borderWidth: 1,
                bgcolor: "background.paper",
                height: "100%",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    display: "flex",
                    gap: 0.5,
                    zIndex: 2,
                }}
            >
                {/* <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation()
                        handleOpenInNewTab(item.id)
                    }}
                >
                    <OpenInNew fontSize="small" />
                </IconButton> */}
            </Box>
            <CardActionArea
                onClick={() => onClick(item.id)}
                disableRipple={false}
                sx={{ height: "100%", alignItems: "flex-start" }}

            >
                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%" }}>

                    {/* Top: checkbox + título */}
                    <Box display="flex" alignItems="flex-start" gap={1}>
                        {selectable && <Checkbox
                            checked={selected}
                            size="small"
                            disableRipple
                            tabIndex={-1}
                            sx={{ p: 0, mt: "2px", flexShrink: 0, pointerEvents: "none" }}
                        />}
                        <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                            {item.id}
                        </Typography>
                    </Box>

                    <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                        {item.title}
                    </Typography>

                    {/* Descrição */}
                    {desc && (
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                            {desc.length > 110 ? desc.slice(0, 110) + "…" : desc}
                        </Typography>
                    )}

                    {/* Keywords + badge interno */}
                    <Box display="flex" flexWrap="wrap" gap={0.75} alignItems="center" mt="auto" pt={0.5}>
                        {
                            keywords.map(({ knowledgebasekeyword }) => (
                                <div className='kb-key' >{knowledgebasekeyword.word}</div>
                            ))
                        }
                        {moreKeywords.length > 0 && (
                            <HtmlTooltip
                                interactive
                                placement="bottom-start"
                                title={
                                    <Fragment >
                                        <div className='kb-tooltip'>
                                            {moreKeywords.map((kItem, key) => { return <div className='kb-key kb-key-tooltip' style={{ height: '100%' }} key={key}>{kItem.knowledgebasekeyword.word}</div> })}
                                        </div>
                                    </Fragment>
                                }
                            >
                                <div className='kb-key' >+{(keywordsList.length - 2)}</div>
                            </HtmlTooltip>
                        )}
                        {/* {item.onlyinternaluse && (
                            <Chip
                                label="Interno"
                                size="small"
                                color="warning"
                                sx={{ fontSize: 11, height: 20, ml: "auto" }}
                            />
                        )} */}
                    </Box>

                    {/* Meta: autor + data */}
                    <Typography variant="caption" color="text.disabled">
                        por {item.user?.name} · {formatDate(item.createdat)}
                    </Typography>

                </CardContent>
                {
                    !selectable &&
                    (
                        <Box
                            sx={{
                                position: "absolute",
                                bottom: 6,
                                right: 6,
                                display: "flex",
                                gap: 0.5,
                                zIndex: 2,
                            }}
                        >
                            <IconButton
                                size="small"
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(item)
                                }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Box>
                    )
                }
            </CardActionArea>
        </Card>
    )
}

export default KnowledgeBaseCard